import { render, staticRenderFns } from "./SiteTypesList.vue?vue&type=template&id=50485cfb&scoped=true&"
import script from "./SiteTypesList.vue?vue&type=script&lang=js&"
export * from "./SiteTypesList.vue?vue&type=script&lang=js&"
import style0 from "./SiteTypesList.vue?vue&type=style&index=0&id=50485cfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50485cfb",
  null
  
)

component.options.__file = "SiteTypesList.vue"
export default component.exports